module.exports = __webpack_public_path__ + "static/media/trusted_shops_logo.76da1dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/redesign/trusted_shops_logo.png
// module id = 166
// module chunks = 0